
  export default {
    init() {
      // JavaScript to be fired on all pages

      /*Valikon avaava animaatio
      $('.hamburger-header').click(function () {
        $('.close-button-container').toggleClass('visible');
      }); */

        /*global Foundation:true*/
        /* exported Foundation */
        var $accordion = new Foundation.AccordionMenu($('.product-categories'), {
          slideSpeed: 300,
          multiOpen: true,
          parentLink: true,
          submenuToggle: true,
        });

        $($accordion).foundation(); 

        $( '.product-categories' ).prepend('<li class="cat-item" role="treeitem"><a href="/tuotteet">Kaikki tuotteet</a></li>' );

      $(window).on('resize', function () {
          if ($(window).width() > 1024) {
            $('.site-header__menu-container').removeClass('site-header__menu-container--open');
            $('.hamburger').removeClass('hamburger--active');
            $('html').removeClass('navigation-open');
          } 
      });

       //Valikon avaava animaatio
    $('.hamburger').click(function () {
      $('html').addClass('navigation-open');
    });

    $('.js-off-canvas-overlay').click(function () {
      $('html').removeClass('navigation-open');
    });

    $('.close-button-container').click(function () {
      $('html').removeClass('navigation-open');
    });

    //Tarjouspyynnön empty-messagen tekstin muutos

    $('.ywraq_list_empty_message' ).text('Lista on tyhjä, lisää tuotteita lähettääksesi tarjouspyyntö.');

    $(window).on('resize', function () {
      if ($(window).width() > 1024) {
        $('html').removeClass('navigation-open');
      } 
  });

        // Ankkurilinkitys

    $(function () {
      $('a[href*="#"]:not([href="#"])').click(function () {
        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          if (target.length) {
            $('html, body').animate({
              scrollTop: target.offset().top - 100,
            }, 1000);
            return false;
          }
        }
      });
    });

     // $('.shop .woocommerce-breadcrumb,.shop .woocommerce-products-header').wrapAll('<div class="woocommerce-header__container"></div>');
     // $('.woocommerce-header__container').wrap('<div class="woocommerce-header"></div>');


      $('#menu-paavalikko').on(
        'show.zf.dropdownmenu', function() {
          var dropdown = $(this).find('.is-dropdown-submenu');
          dropdown.css('display', 'none');
          dropdown.fadeIn('fast');
      });
      $('#menu-paavalikko').on(
        'hide.zf.dropdownmenu', function() {
          var dropdown = $(this).find('.is-dropdown-submenu');
          dropdown.css('display', 'inherit');
          dropdown.fadeOut('fast');
      });

      $('.product-info-tags .tag').not(':last-child').append(',');


      $('.woocommerce-tabs').appendTo('.product-information-single');
      $('.product-additional-information').appendTo('.product-information-single');

    },
    finalize() {
      // JavaScript to be fired on all pages, after page specific JS is fired
    },
  };



// WEBPACK FOOTER //
// ./scripts/routes/common.js